import { createActions, using } from "redux-box";

export default createActions({
  requestLeaderBoardList: using("offset"),
  requestFreadomPointLeaderBoardList: using("offset"),
  setSearchLeaderBoard: using("search"),
  setSearchFreadomLeaderBoard: using("search"),
});
